/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Question_1Inputs */

const en_help_center__bidding_n_battles__question_1 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens if I run out of bids during a battle?`)
};

/**
* | output |
* | --- |
* | "What happens if I run out of bids during a battle?" |
*
* @param {Help_Center__Bidding_N_Battles__Question_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__question_1 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Question_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Question_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__question_1(inputs)
});